import styled from '@emotion/styled';
import React, { memo, FC, CSSProperties } from 'react';
import { MathJax } from 'better-react-mathjax';

import { Handle, Position, NodeProps, Connection, Edge } from 'react-flow-renderer';

const targetHandleStyle: CSSProperties = { background: 'transparent', };
const sourceHandleStyleA: CSSProperties = { ...targetHandleStyle, top: 0 };
const sourceHandleStyleB: CSSProperties = { ...targetHandleStyle, bottom: 10};
const sourceHandleStyleC: CSSProperties = { ...targetHandleStyle, bottom: 20};

const Box = styled.div`
  background: #FFE6CC;
  border: solid 1px #D79B00;
  margin: 5px;
  width: 60px;
  padding: 20px;
  text-align: center;
`

const EdgeTxt = styled.div`
  position: absolute;
  right: 20px;
  top: -80px;
`;

const onConnect = (params: Connection | Edge) => console.log('handle onConnect', params);

const Px: FC<NodeProps> = ({ data, isConnectable }) => {
  const f = "\\(\P_c \\)";
  return (
    <Box>
      <Handle
        type="target"
        position={Position.Left}
        style={targetHandleStyle}
        onConnect={onConnect}
      />
      <EdgeTxt>
        α<sub>p</sub>
      </EdgeTxt>
      {/* <MathJax>{f}</MathJax> */}
      <MathJax>
        ρ<sub>p|s,X</sub>
      </MathJax>
      <Handle
        type="source"
        position={Position.Top}
        style={sourceHandleStyleB}
        isConnectable={isConnectable}
      />
    </Box>
  );
};

export default memo(Px);
